import { Component, OnInit, Input } from '@angular/core';
declare var $: any;
@Component({
    selector: 'app-home-listing',
    templateUrl: './home-listing.component.html',
    styleUrls: ['./home-listing.component.css'],
    standalone: false
})
export class HomeListingComponent implements OnInit {

  constructor() { }
  @Input() NewlyAdded = [];
  @Input() IsLoading = false;

  ngOnInit(): void {
  }

  showSlider(item: any) {
    const $lg = $('#dynamicLightGallery');
    $lg.unbind();
    // tslint:disable-next-line: only-arrow-functions
    const imageArray = $.makeArray(item.Images).map(function (image, i) {
      return ({
        src: image,
        thumb: image,
        // tslint:disable-next-line: max-line-length
        subHtml: '<div><h2 ><a href="#" style="color:#fff;">' + item.Title + '</a></h2></div>'
      });
    });

    $lg.lightGallery({
      mode: 'lg-fade',
      cssEasing: 'ease',
      download: false,
      counter: false,
      autoplayControls: false,
      dynamic: true,
      zoom: false,
      fullScreen: false,
      googlePlus: false,
      pinterest: true,
      dynamicEl: imageArray
    });


    $lg.on('onCloseAfter.lg', function (event) {
      $lg.data('lightGallery').destroy(true);
    });
  }
}



